<div class="sidebar" role="dialog">

	<app-sidebar-header [title]="'extrasSidebar.findHotels.title.addressMap' | ibeadmin | async" [label]="hotelName" >

	</app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar-wrapper" #sidebar__body>

		<div class="title-h2">{{ address }} </div>

		<p>
			{{ description }}
		</p>

		<iframe class="block-iframe" [src]="url" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
	</div>
</div>